import type { Table, Category, Product, Order, KitchenOrder, User, Shift, ActivityLog } from './pos-types';

// Usuario activo
export const currentUser: User = {
  id: '1',
  name: 'Juan Pérez',
  role: 'admin',
};

// Turno activo
export const currentShift: Shift = {
  id: '1',
  startedAt: new Date(),
  cashier: 'María García',
  initialCash: 50000,
};

// Zonas del restaurante
export const zones = ['Terraza', 'Interior', 'Bar', 'VIP'];

// Mesas
export const tables: Table[] = [
  { id: '1', number: 1, capacity: 2, status: 'available', zone: 'Terraza', layoutGx: 1, layoutGy: 1, layoutSize: 1, layoutShape: 'square' },
  { id: '2', number: 2, capacity: 4, status: 'occupied', zone: 'Terraza', layoutGx: 3, layoutGy: 1, layoutSize: 1, layoutShape: 'square', waiter: 'Juan', openedAt: new Date(Date.now() - 25 * 60000), currentOrderId: 'o1' },
  { id: '3', number: 3, capacity: 4, status: 'occupied', zone: 'Terraza', layoutGx: 5, layoutGy: 1, layoutSize: 2, layoutShape: 'rect', waiter: 'Juan', openedAt: new Date(Date.now() - 45 * 60000), currentOrderId: 'o2' },
  { id: '4', number: 4, capacity: 6, status: 'available', zone: 'Terraza', layoutGx: 1, layoutGy: 3, layoutSize: 1, layoutShape: 'round' },
  { id: '5', number: 5, capacity: 2, status: 'blocked', zone: 'Interior', layoutGx: 3, layoutGy: 3, layoutSize: 2, layoutShape: 'round', blockedReason: 'En mantenimiento' },
  { id: '6', number: 6, capacity: 4, status: 'pending-payment', zone: 'Interior', layoutGx: 6, layoutGy: 3, layoutSize: 1, layoutShape: 'square', waiter: 'Ana', openedAt: new Date(Date.now() - 60 * 60000), currentOrderId: 'o3' },
  { id: '7', number: 7, capacity: 4, status: 'available', zone: 'Interior', layoutGx: 1, layoutGy: 5, layoutSize: 3, layoutShape: 'rect' },
  { id: '8', number: 8, capacity: 8, status: 'occupied', zone: 'Interior', layoutGx: 4, layoutGy: 5, layoutSize: 1, layoutShape: 'round', waiter: 'Juan', openedAt: new Date(Date.now() - 12 * 60000), currentOrderId: 'o4' },
  { id: '9', number: 9, capacity: 2, status: 'available', zone: 'Bar', layoutGx: 1, layoutGy: 1, layoutSize: 1, layoutShape: 'round' },
  { id: '10', number: 10, capacity: 2, status: 'occupied', zone: 'Bar', layoutGx: 3, layoutGy: 1, layoutSize: 1, layoutShape: 'round', waiter: 'Pedro', openedAt: new Date(Date.now() - 35 * 60000), currentOrderId: 'o5' },
  { id: '11', number: 11, capacity: 4, status: 'available', zone: 'Bar', layoutGx: 5, layoutGy: 2, layoutSize: 2, layoutShape: 'round' },
  { id: '12', number: 12, capacity: 6, status: 'available', zone: 'VIP', layoutGx: 1, layoutGy: 1, layoutSize: 1, layoutShape: 'square' },
  { id: '13', number: 13, capacity: 8, status: 'occupied', zone: 'VIP', layoutGx: 3, layoutGy: 1, layoutSize: 2, layoutShape: 'square', waiter: 'Juan', openedAt: new Date(Date.now() - 55 * 60000), currentOrderId: 'o6' },
  { id: '14', number: 14, capacity: 10, status: 'available', zone: 'VIP', layoutGx: 1, layoutGy: 3, layoutSize: 3, layoutShape: 'rect' },
  { id: '15', number: 15, capacity: 4, status: 'pending-payment', zone: 'Interior', layoutGx: 4, layoutGy: 3, layoutSize: 1, layoutShape: 'square', waiter: 'Ana', openedAt: new Date(Date.now() - 70 * 60000), currentOrderId: 'o7' },
  { id: '16', number: 16, capacity: 2, status: 'available', zone: 'Terraza', layoutGx: 6, layoutGy: 3, layoutSize: 1, layoutShape: 'square' },
];

// Categorías
export const categories: Category[] = [
  { id: 'c1', name: 'Entradas', icon: 'salad', order: 1 },
  { id: 'c2', name: 'Fondos', icon: 'utensils', order: 2 },
  { id: 'c3', name: 'Bebidas', icon: 'wine', order: 3 },
  { id: 'c4', name: 'Postres', icon: 'cake', order: 4 },
  { id: 'c5', name: 'Cervezas', icon: 'beer', order: 5 },
  { id: 'c6', name: 'Tragos', icon: 'cocktail', order: 6 },
];

// Productos
export const products: Product[] = [
  // Entradas
  { id: 'p1', name: 'Empanadas (3u)', description: 'Carne, pollo o queso', price: 4500, categoryId: 'c1', available: true, preparationTime: 8 },
  { id: 'p2', name: 'Nachos Supremos', description: 'Con guacamole, queso y jalapeños', price: 6800, categoryId: 'c1', available: true, preparationTime: 10 },
  { id: 'p3', name: 'Tabla de Quesos', description: 'Selección de quesos artesanales', price: 8500, categoryId: 'c1', available: true, preparationTime: 5 },
  { id: 'p4', name: 'Ceviche', description: 'Pescado fresco con limón', price: 7200, categoryId: 'c1', available: true, preparationTime: 12 },
  // Fondos
  { id: 'p5', name: 'Hamburguesa Clásica', description: '200g de carne, lechuga, tomate', price: 9500, categoryId: 'c2', available: true, preparationTime: 15 },
  { id: 'p6', name: 'Lomo Saltado', description: 'Con arroz y papas fritas', price: 12500, categoryId: 'c2', available: true, preparationTime: 18 },
  { id: 'p7', name: 'Pasta Carbonara', description: 'Spaghetti con salsa cremosa', price: 10800, categoryId: 'c2', available: true, preparationTime: 12 },
  { id: 'p8', name: 'Salmón Grillado', description: 'Con puré y vegetales', price: 15500, categoryId: 'c2', available: false, preparationTime: 20 },
  { id: 'p9', name: 'Costillas BBQ', description: 'Rack completo con papas', price: 16800, categoryId: 'c2', available: true, preparationTime: 25 },
  { id: 'p10', name: 'Pizza Margarita', description: 'Tomate, mozzarella, albahaca', price: 8900, categoryId: 'c2', available: true, preparationTime: 15 },
  // Bebidas
  { id: 'p11', name: 'Coca-Cola', description: '350ml', price: 2500, categoryId: 'c3', available: true },
  { id: 'p12', name: 'Agua Mineral', description: '500ml', price: 1800, categoryId: 'c3', available: true },
  { id: 'p13', name: 'Jugo Natural', description: 'Naranja, piña o frutilla', price: 3200, categoryId: 'c3', available: true },
  { id: 'p14', name: 'Limonada', description: 'Con menta y jengibre', price: 3500, categoryId: 'c3', available: true },
  // Postres
  { id: 'p15', name: 'Tiramisú', description: 'Clásico italiano', price: 5500, categoryId: 'c4', available: true },
  { id: 'p16', name: 'Brownie con Helado', description: 'Chocolate caliente', price: 4800, categoryId: 'c4', available: true },
  { id: 'p17', name: 'Cheesecake', description: 'Con frutos rojos', price: 5200, categoryId: 'c4', available: true },
  // Cervezas
  { id: 'p18', name: 'Cerveza Artesanal IPA', description: '500ml', price: 4500, categoryId: 'c5', available: true },
  { id: 'p19', name: 'Cerveza Lager', description: '330ml', price: 3200, categoryId: 'c5', available: true },
  { id: 'p20', name: 'Cerveza Stout', description: '500ml', price: 4800, categoryId: 'c5', available: true },
  // Tragos
  { id: 'p21', name: 'Pisco Sour', description: 'Clásico peruano', price: 5500, categoryId: 'c6', available: true },
  { id: 'p22', name: 'Mojito', description: 'Ron, menta, limón', price: 5200, categoryId: 'c6', available: true },
  { id: 'p23', name: 'Margarita', description: 'Tequila, triple sec, limón', price: 5800, categoryId: 'c6', available: true },
];

// Órdenes activas
export const orders: Order[] = [
  {
    id: 'o1',
    tableId: '2',
    tableNumber: 2,
    waiter: 'Juan',
    status: 'in-kitchen',
    createdAt: new Date(Date.now() - 25 * 60000),
    updatedAt: new Date(Date.now() - 20 * 60000),
    items: [
      { id: 'i1', productId: 'p5', productName: 'Hamburguesa Clásica', quantity: 2, unitPrice: 9500, status: 'in-progress', addedAt: new Date() },
      { id: 'i2', productId: 'p11', productName: 'Coca-Cola', quantity: 2, unitPrice: 2500, status: 'delivered', addedAt: new Date() },
    ],
    subtotal: 24000,
    tax: 4560,
    total: 28560,
  },
  {
    id: 'o2',
    tableId: '3',
    tableNumber: 3,
    waiter: 'Juan',
    status: 'delivered',
    createdAt: new Date(Date.now() - 45 * 60000),
    updatedAt: new Date(Date.now() - 10 * 60000),
    items: [
      { id: 'i3', productId: 'p6', productName: 'Lomo Saltado', quantity: 1, unitPrice: 12500, status: 'delivered', addedAt: new Date() },
      { id: 'i4', productId: 'p21', productName: 'Pisco Sour', quantity: 2, unitPrice: 5500, status: 'delivered', addedAt: new Date() },
    ],
    subtotal: 23500,
    tax: 4465,
    total: 27965,
  },
  {
    id: 'o3',
    tableId: '6',
    tableNumber: 6,
    waiter: 'Ana',
    status: 'pending-payment',
    createdAt: new Date(Date.now() - 60 * 60000),
    updatedAt: new Date(Date.now() - 5 * 60000),
    items: [
      { id: 'i5', productId: 'p7', productName: 'Pasta Carbonara', quantity: 2, unitPrice: 10800, status: 'delivered', addedAt: new Date() },
      { id: 'i6', productId: 'p12', productName: 'Agua Mineral', quantity: 2, unitPrice: 1800, status: 'delivered', addedAt: new Date() },
      { id: 'i7', productId: 'p15', productName: 'Tiramisú', quantity: 1, unitPrice: 5500, status: 'delivered', addedAt: new Date() },
    ],
    subtotal: 30700,
    tax: 5833,
    total: 36533,
  },
  {
    id: 'o7',
    tableId: '15',
    tableNumber: 15,
    waiter: 'Ana',
    status: 'pending-payment',
    createdAt: new Date(Date.now() - 70 * 60000),
    updatedAt: new Date(Date.now() - 3 * 60000),
    items: [
      { id: 'i13', productId: 'p10', productName: 'Pizza Margarita', quantity: 1, unitPrice: 8900, status: 'delivered', addedAt: new Date() },
      { id: 'i14', productId: 'p18', productName: 'Cerveza Artesanal IPA', quantity: 2, unitPrice: 4500, status: 'delivered', addedAt: new Date() },
    ],
    subtotal: 17900,
    tax: 3401,
    total: 21301,
  },
];

// Órdenes de cocina con timestamps y QR
export const kitchenOrders: KitchenOrder[] = [
  {
    id: 'k1',
    orderId: 'o1',
    tableNumber: 2,
    items: [
      { id: 'i1', productId: 'p5', productName: 'Hamburguesa Clásica', quantity: 2, unitPrice: 9500, status: 'in-progress', notes: 'Sin cebolla', addedAt: new Date() },
    ],
    createdAt: new Date(Date.now() - 8 * 60000),
    receivedAt: new Date(Date.now() - 8 * 60000),
    status: 'preparing',
    startTime: new Date(Date.now() - 8 * 60000),
    isPriority: false,
    type: 'Local',
    qrCode: 'CMD-001-M2-' + Date.now(),
    ticketPrinted: true,
  },
  {
    id: 'k2',
    orderId: 'o4',
    tableNumber: 8,
    items: [
      { id: 'i8', productId: 'p9', productName: 'Costillas BBQ', quantity: 1, unitPrice: 16800, status: 'pending', addedAt: new Date() },
      { id: 'i9', productId: 'p2', productName: 'Nachos Supremos', quantity: 1, unitPrice: 6800, status: 'in-progress', addedAt: new Date() },
    ],
    createdAt: new Date(Date.now() - 5 * 60000),
    receivedAt: new Date(Date.now() - 5 * 60000),
    status: 'pending',
    startTime: new Date(Date.now() - 5 * 60000),
    isPriority: true,
    type: 'Local',
    qrCode: 'CMD-002-M8-' + Date.now(),
    ticketPrinted: true,
  },
  {
    id: 'k3',
    orderId: 'o5',
    tableNumber: 10,
    items: [
      { id: 'i10', productId: 'p4', productName: 'Ceviche', quantity: 1, unitPrice: 7200, status: 'in-progress', addedAt: new Date() },
    ],
    createdAt: new Date(Date.now() - 18 * 60000),
    receivedAt: new Date(Date.now() - 18 * 60000),
    status: 'preparing',
    startTime: new Date(Date.now() - 18 * 60000),
    isPriority: false,
    type: 'Web',
    qrCode: 'CMD-003-M10-' + Date.now(),
    ticketPrinted: true,
  },
  {
    id: 'k4',
    orderId: 'o6',
    tableNumber: 13,
    items: [
      { id: 'i11', productId: 'p6', productName: 'Lomo Saltado', quantity: 3, unitPrice: 12500, status: 'pending', addedAt: new Date() },
      { id: 'i12', productId: 'p7', productName: 'Pasta Carbonara', quantity: 2, unitPrice: 10800, status: 'pending', addedAt: new Date() },
    ],
    createdAt: new Date(Date.now() - 2 * 60000),
    receivedAt: new Date(Date.now() - 2 * 60000),
    status: 'pending',
    startTime: new Date(Date.now() - 2 * 60000),
    isPriority: false,
    type: 'Web',
    qrCode: 'CMD-004-M13-' + Date.now(),
    ticketPrinted: true,
  },
];

// Log de actividad del dia
export const activityLogs: ActivityLog[] = [
  { id: 'log1', timestamp: new Date(Date.now() - 180 * 60000), actor: 'María García', actorRole: 'cashier', action: 'table_opened', tableNumber: 2, details: 'Mesa 2 abierta con 4 comensales' },
  { id: 'log2', timestamp: new Date(Date.now() - 175 * 60000), actor: 'Juan Pérez', actorRole: 'waiter', action: 'order_sent', tableNumber: 2, details: 'Pedido enviado a cocina: 2 Hamburguesas' },
  { id: 'log3', timestamp: new Date(Date.now() - 160 * 60000), actor: 'Carlos Chef', actorRole: 'kitchen', action: 'order_ready', tableNumber: 2, details: 'Pedido listo - Tiempo: 15 min' },
  { id: 'log4', timestamp: new Date(Date.now() - 155 * 60000), actor: 'Juan Pérez', actorRole: 'waiter', action: 'order_delivered', tableNumber: 2, details: 'Pedido entregado en mesa' },
  { id: 'log5', timestamp: new Date(Date.now() - 120 * 60000), actor: 'María García', actorRole: 'cashier', action: 'payment_received', tableNumber: 2, details: 'Pago recibido: $28,560 (Tarjeta)' },
  { id: 'log6', timestamp: new Date(Date.now() - 119 * 60000), actor: 'Sistema', actorRole: 'admin', action: 'table_closed', tableNumber: 2, details: 'Mesa liberada automaticamente' },
  { id: 'log7', timestamp: new Date(Date.now() - 60 * 60000), actor: 'Admin', actorRole: 'admin', action: 'product_unavailable', details: 'Salmón Grillado marcado como agotado' },
  { id: 'log8', timestamp: new Date(Date.now() - 45 * 60000), actor: 'Ana López', actorRole: 'waiter', action: 'table_opened', tableNumber: 6, details: 'Mesa 6 abierta con 2 comensales' },
];

// Función helper para formatear precio
export function formatPrice(price: number): string {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
  }).format(price);
}

// Función para obtener color de estado de mesa
export function getTableStatusColor(status: Table['status']): string {
  switch (status) {
    case 'available':
      return 'bg-emerald-500/20 border-emerald-500 text-emerald-400';
    case 'occupied':
      return 'bg-amber-500/20 border-amber-500 text-amber-400';
    case 'blocked':
      return 'bg-zinc-500/20 border-zinc-500 text-zinc-400';
    case 'pending-payment':
      return 'bg-violet-500/20 border-violet-500 text-violet-400';
    default:
      return 'bg-zinc-500/20 border-zinc-500 text-zinc-400';
  }
}

// Función para obtener etiqueta de estado de mesa
export function getTableStatusLabel(status: Table['status']): string {
  switch (status) {
    case 'available':
      return 'Disponible';
    case 'occupied':
      return 'Ocupada';
    case 'blocked':
      return 'Bloqueada';
    case 'pending-payment':
      return 'Por pagar';
    default:
      return 'Desconocido';
  }
}
